import { apiDelete } from '@/infrastructure/api-client';
import type { PresentationAssetRef } from '@/domain/presentation/contracts';

/** SPEC-011 §87/plan §31 — mirrors `attachment-api.ts`'s FormData upload pattern. */
export async function uploadPresentationLogo(
  funnelId: string,
  file: File,
): Promise<PresentationAssetRef> {
  const form = new FormData();
  form.set('file', file);
  const path = `/api/funnels/${funnelId}/presentation/assets`;
  const response = await fetch(path, { method: 'POST', body: form, credentials: 'include' });
  if (!response.ok) {
    const body = (await response.json().catch(() => null)) as {
      error?: { message?: string };
    } | null;
    throw new Error(body?.error?.message ?? 'Logo upload failed.');
  }
  return ((await response.json()) as { asset: PresentationAssetRef }).asset;
}

export function presentationLogoUrl(funnelId: string, assetId: string): string {
  return `/api/funnels/${funnelId}/presentation/assets/${assetId}`;
}

export async function deletePresentationLogo(funnelId: string, assetId: string): Promise<void> {
  await apiDelete(`/api/funnels/${funnelId}/presentation/assets/${assetId}`);
}
